import styled from '@emotion/styled'

export const Background = styled.div`
    position: relative;
    width: 100%;
    height: 328px;
    z-index: 0;

    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        height: 456px;
    }
`

export const ImageContent = styled.div`
    position: absolute;
    inset: 0;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const TextContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    max-width: ${(props) => props.theme.containerWidth};
    padding: 0 16px;
    color: white;
    gap: 32px;

    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        padding: 16px 128px;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.largePhone}) {
        flex-direction: column;
        align-items: center;
        gap: 32px;
        padding: 16px 0px;
    }
`

export const LeftContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0px;
    padding: 0px 16px;

    h2 {
        font-family: Yantramanav-Bold;
        letter-spacing: -3px;
        font-size: 64px;
        margin-bottom: -32px;
        margin-top: unset;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        padding: unset;
        h2 {
            font-size: 40px;
            margin-bottom: -16px;
        }
    }
`

export const RightContainer = styled.div`
    flex: 1;
    display: flex;
    color: #fff;
    flex-direction: column;
    line-height: 150%;
    gap: 32px;
    padding: 0px 16px;

    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        max-width: 394px;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.largePhone}) {
        align-items: center;
    }
`

export const BackgroundImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
`

export const FloatingSquareImage = styled.img`
    position: absolute;
    top: -10%;
    left: calc(50% - 540px);
    width: 33px;
    height: 92px;
    object-fit: cover;
    z-index: 10;

    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        left: 16px;
        top: -10%;
        left: calc(50% - 450px);
        width: 27px;
        height: 81px;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.largePhone}) {
        left: 16px;
        top: -10%;
        left: calc(50% - 250px);
        width: 27px;
        height: 81px;
    }
`
